import * as React from 'react';
import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { TimerRegular } from '@fluentui/react-icons';
import { defineMessage, useIntl } from 'react-intl';

interface Props {
  timeInMins: number;
}

export function ReadTimeLabel(props: Props) {
  const intl = useIntl();
  const classes = useStyles();

  const hours = Math.floor(props.timeInMins / 60);
  const minutes = props.timeInMins % 60;

  return (
    <Text className={classes.text}>
      <TimerRegular fontSize={20} />
      {intl.formatMessage(hours ? timeHoursLabel : timeMinutesLabel, {
        hours,
        minutes,
      })}
    </Text>
  );
}

const timeHoursLabel = defineMessage({
  defaultMessage: '{hours, number} hr {minutes, number} min',
  description: 'description',
});

const timeMinutesLabel = defineMessage({
  defaultMessage: '{minutes, number} min',
  description: 'description',
});

const useStyles = makeStyles({
  text: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalXXS,
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase300,
  },
});
